<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark navbar-stick-dark" data-navbar="sticky">
      <header-component></header-component>
    </nav>
    <!-- Header -->
    <header class="header pt-10 pb-0">
      <div class="container text-center">
        <h1 class="display-4">Let's Get In Touch</h1>
        <p class="lead-2 mt-6">Here are the ways you can contact us with any questions you have</p>
      </div>
    </header>
    <!-- /.header -->

    <!-- Main Content -->
    <main class="main-content">
      <!--
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Contact form
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      !-->
      <section class="section">
        <div class="container">
          <div class="row">
            <form class="col-lg-6 mx-auto p-6 bg-gray rounded">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <input
                    class="form-control form-control-lg"
                    v-model="user.name"
                    type="text"
                    name="name"
                    placeholder="Your Name"
                  />
                </div>

                <div class="form-group col-md-6">
                  <input
                    class="form-control form-control-lg"
                    v-model="user.phone"
                    name="phone"
                    placeholder="Your Contact No."
                  />
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-lg"
                  v-model="user.email"
                  type="email"
                  name="email"
                  placeholder="Your Email Address"
                />
              </div>

              <div class="form-group">
                <textarea
                  class="form-control form-control-lg"
                  v-model="user.message"
                  rows="4"
                  placeholder="Your Message"
                  name="message"
                ></textarea>
              </div>

              <div class="text-center">
                <button class="btn btn-lg btn-primary" @click="submitInquiry()">
                  Submit Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <!--
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Map
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      !-->
      <section
        class="section bg-dark bg-img"
        :style="{ 'background-image': `url('${backgroundImage}')` }"
        data-overlay="6"
      >
        <div class="container">
          <div class="row gap-y align-items-center">
            <div class="col-md-5 text-white">
              <p class="text-uppercase small opacity-70 fw-600 ls-1">Head Office</p>
              <h5>Baner, Pune</h5>
              <br />
              <p>A-407, Wellworth Paradise,<br />Pancard Club Road, Baner</p>
              <p>Phone: +91 8668288617<br />Email: support@amsainfotech.com</p>
              <br />
              <h6>Follow Us</h6>
              <div class="social social-sm social-inverse">
                <a
                  class="social-facebook"
                  href="https://www.facebook.com/amsainfotech/?modal=admin_todo_tour"
                  target="blank"
                  ><i class="fa fa-facebook"></i
                ></a>
                <a
                  class="social-linkedin"
                  href="https://www.linkedin.com/company/amsa-infotech-pvt-ltd"
                  target="blank"
                  ><i class="fa fa-linkedin"></i
                ></a>
              </div>
            </div>
            <div class="col-md-7">
              <div
                class="h-400 rounded"
                data-provide="map"
                data-lat="18.5560438"
                data-lng="73.7813759"
                data-zoom="14"
                data-marker-lat="18.5560438"
                data-marker-lng="73.7813759"
                data-info="&lt;strong&gt;Our office&lt;/strong&gt;&lt;br&gt;A-407, Welworth Paradise, Pan card club road, baner, pune, MH - 411 045, India"
                data-style="standard"
              ></div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- /.main-content -->
  </div>
</template>
<script>
import axios from "axios";
import header from "../../components/Header.vue";

import backgroundImage from "../../assets/img/thumb/14.jpg";

export default {
  data: () => ({
    backgroundImage,
    user: {
      name: "",
      phone: "",
      email: "",
      message: "",
    },
  }),
  components: {
    "header-component": header,
  },
  methods: {
    submitInquiry() {
      axios.post("http://api.amsainfotech.com/api/v1/email", this.user).then((res) => {
        console.log("res => ", res);
        if (res) {
          this.notify({
            message: "Received",
            type: "success",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.dialog {
  color: black;
}
</style>
